//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared';
import {
  TAjaxFeedbackModel,
  IAjaxFeedbackRequest,
  IMappers,
  IAjaxFeedbackResponse,
  IAjaxFeedbackResponseError,
  TAjaxFeedbackResponse,
} from './types';

const defaultConfig: TAjaxFeedbackModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: '/ajax/feedback/',
  hostType: 'api',
  responseContentType: 'json',
} as TAjaxFeedbackModel;

function createAjaxFeedbackModel(parameters: IAjaxFeedbackRequest): TAjaxFeedbackModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAjaxFeedbackOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IAjaxFeedbackRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchAjaxFeedback<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IAjaxFeedbackOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TAjaxFeedbackResponse> {
  const { response, statusCode } = await httpApi.fetch(createAjaxFeedbackModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAjaxFeedbackResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IAjaxFeedbackResponseError);
    }
  }

  return { response, statusCode } as TAjaxFeedbackResponse;
}

export { defaultConfig, createAjaxFeedbackModel, fetchAjaxFeedback };
